import Vue from "vue";
import VueRouter from "vue-router";
import adminRoutes from "../router/admin";

Vue.use(VueRouter);

const routes = [...adminRoutes];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
